<template>
  <main>
    <div class="bg-gray-200 py-2">
      <div class="breadcrumbs container mx-auto">
        <nuxt-link :to="localePath('index')" class="breadcrumb px-2">
          {{ $t('home') }}
        </nuxt-link>
        <nuxt-link
          :to="localePath('local-information')"
          class="breadcrumb px-2"
        >
          {{ $t('LOCAL_INFORMATION') }}
        </nuxt-link>
        <nuxt-link
          :to="
            localePath({
              name: 'local-information-slug',
              params: { slug: market.slug }
            })
          "
          class="breadcrumb px-2"
        >
          {{ market.name[this.$i18n.locale] }}
        </nuxt-link>
      </div>
    </div>
    <div class="header text-center py-32">
      <vue-typer
        :text="
          market.slug === 'usa' && this.$i18n.locale === 'sr'
            ? 'Naše usluge na SAD tržištu'
            : $t('our_solutions_in') + ' ' + market.name[this.$i18n.locale]
        "
        :repeat="0"
        :pre-type-delay="1000"
        :type-delay="150"
        class="text-4xl block font-bold text-white leading-tight mb-6"
      ></vue-typer>
    </div>
    <section v-scroll-reveal class="market px-4 container mx-auto">
      <div class="market-content bg-white px-8 py-8 md:px-20 md:py-20">
        <div class="flex justify-between">
          <h3 class="text-2xl font-semibold mb-4">{{ $t('overview') }}</h3>
          <nuxt-link
            v-if="market.slug === 'bosnia'"
            :to="localePath('local-information-bosnia-m-one-i')"
            class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded mb-4"
          >
            {{ $t('deliveryService') }}
          </nuxt-link>
          <nuxt-link
            v-if="market.slug === 'albania'"
            :to="localePath('local-information-albania-m-one-i')"
            class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded mb-4"
          >
            {{ $t('deliveryService') }}
          </nuxt-link>
          <nuxt-link
            v-if="market.slug === 'montenegro'"
            :to="localePath('local-information-montenegro-m-one-i')"
            class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded mb-4"
          >
            {{ $t('deliveryService') }}
          </nuxt-link>
          <nuxt-link
            v-if="market.slug === 'macedonia'"
            :to="localePath('local-information-macedonia-m-one-i')"
            class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded mb-4"
          >
            {{ $t('shippingServices') }}
          </nuxt-link>
        </div>
        <div
          v-html="market.description[this.$i18n.locale]"
          class="text-grey-600 mb-5 additional-info"
        ></div>
        <div v-if="market.slug === 'usa'">
          <p>
            Milsped Freight LLC –
            <nuxt-link
              :to="localePath('local-information-usa-freight')"
              class="text-blue-600 underline"
            >
              {{ $t('more_about_service') }}
            </nuxt-link>
          </p>
          <p>
            Milsped Air & Sea LLC –
            <nuxt-link
              :to="localePath('local-information-usa-air-sea')"
              class="text-blue-600 underline"
            >
              {{ $t('more_about_service') }}
            </nuxt-link>
          </p>
          <p class="mt-5">
            <a
              :href="pdfPath"
              download="Milsped_Terms_and_Conditions_of_Service.pdf"
              class="text-blue-600 underline"
            >
              Milsped Terms and Conditions of Service
            </a>
          </p>
        </div>
      </div>
    </section>
    <div class="text-center text-white px-4 bg-blue-500 py-20">
      <div class="container mx-auto">
        <h3 class="font-semibold mb-1 text-xl">
          {{ $t('email_your_office') }}
        </h3>
        <p class="mb-6">{{ $t('click_below_to_email') }}</p>
        <a
          :href="`mailto:${market.email}`"
          class="bg-blue-700 hover:bg-blue-800 px-12 uppercase hover:text-white mt-6 text-white px-5 py-3"
        >
          {{ $t('email_us') }}
        </a>
      </div>
    </div>
  </main>
</template>

<script>
import markets from '~/static/markets.json'

export default {
  data() {
    return {
      pdfPath: '/doc/terms/Milsped Terms and Conditions of Service.pdf'
    }
  },
  asyncData({ route, params }) {
    const slug = params.slug
    const market = markets.find(market => {
      return market.slug === slug
    })

    return { market }
  }
}
</script>

<style scoped>
.header {
  background: linear-gradient(to right, rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0)),
    url('/img/about_header_background.jpg');
  background-position: center;
  background-size: cover;
  position: relative;
}
.header:after {
  content: '';
  position: absolute;
  width: 100%;
  height: 100%;
  transform: translateY(100%);
  left: 0;
  bottom: 0;
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0.05), transparent);
  z-index: -1;
}
.market-content {
  transform: translateY(-75px);
  z-index: 999;
}
.card {
  display: flex;
  margin-bottom: 36px;
  min-height: 300px;
}
.card img {
  width: 100%;
  height: auto;
  margin-bottom: 15px;
}
.additional-info h3 {
  @apply my-3;
  @apply font-bold;
}
.additional-info p {
  background: red;
}
@screen md {
  .card:nth-child(odd) {
    flex-direction: row-reverse;
  }

  .card:nth-child(even) div {
    padding-left: 25px;
    padding-right: 0;
  }
  .card img {
    width: 50%;
    height: auto;
    max-height: 350px;
  }
  .card div {
    padding-right: 25px;
    width: 50%;
  }
}
</style>
